import React, { useState, useMemo, useEffect } from 'react';
import { Link } from 'react-router-dom';
import DataTable from 'datatables.net-react';
import DT from 'datatables.net-dt';
import Responsive from 'datatables.net-responsive';
import CircleProgress from '../components/charts/CircleProgress';
import AreaChart from '../components/charts/AreaChart';

DataTable.use(DT);
DataTable.use(Responsive);

const Explorer: React.FC = () => {
    const [dtApi, setDtApi] = useState<any>(null);
    const [menuClosed, setMenuClosed] = useState(false);

    useEffect(() => {
        document.body.classList.toggle('innermenu-close', menuClosed);
        return () => {
            document.body.classList.remove('innermenu-close');
        };
    }, [menuClosed]);

    const options = useMemo(() => ({
        responsive: true,
        pageLength: 10,
        lengthChange: false,
        searching: true,
        dom: 'rtip',
        initComplete: (settings: any) => {
            const api = new DT.Api(settings);
            setDtApi(api);
        }
    }), []);

    const filesData = useMemo(() => [
        { image: 'assets/img/adminuiux/image-1.jpg', name: 'Construction-portal.pdf', uploadedBy: 'Uploaded by me', favorite: true, dateCreated: '28-03-2022', timeCreated: '06:00 pm', dateModified: '29-03-2022', modifiedBy: '08:00 pm by Kevin Doglas', shareStatus: 'Active', shareClass: 'text-bg-theme-1 theme-green', fileSize: '25.5 MB' },
        { image: 'assets/img/adminuiux/image-2.jpg', name: 'save-more-money.pptx', uploadedBy: 'Uploaded by me', favorite: false, dateCreated: '11-03-2022', timeCreated: '06:00 pm', dateModified: '5-04-2022', modifiedBy: '01:11 pm by Me', shareStatus: 'Active', shareClass: 'text-bg-theme-1 theme-green', fileSize: '12.5 MB' },
        { image: 'assets/img/adminuiux/image-3.jpg', name: 'Presentation-2022.pptx', uploadedBy: 'Uploaded by me', favorite: true, dateCreated: '28-03-2022', timeCreated: '06:00 pm', dateModified: '29-03-2022', modifiedBy: '08:00 pm by Kevin Doglas', shareStatus: 'Inactive', shareClass: 'text-bg-secondary', fileSize: '25.5 MB' },
        { image: 'assets/img/adminuiux/image-4.jpg', name: 'Presentation-2022.pptx', uploadedBy: 'Uploaded by me', favorite: false, dateCreated: '28-03-2022', timeCreated: '06:00 pm', dateModified: '29-03-2022', modifiedBy: '08:00 pm by Kevin Doglas', shareStatus: 'Active', shareClass: 'text-bg-theme-1 theme-green', fileSize: '25.5 MB' },
        { image: 'assets/img/adminuiux/image-1.jpg', name: 'Presentation-2022.pptx', uploadedBy: 'Uploaded by me', favorite: true, dateCreated: '28-03-2022', timeCreated: '06:00 pm', dateModified: '29-03-2022', modifiedBy: '08:00 pm by Kevin Doglas', shareStatus: 'Active', shareClass: 'text-bg-theme-1 theme-green', fileSize: '25.5 MB' },
        { image: 'assets/img/adminuiux/image-2.jpg', name: 'Presentation-2022.pptx', uploadedBy: 'Uploaded by me', favorite: false, dateCreated: '28-03-2022', timeCreated: '06:00 pm', dateModified: '29-03-2022', modifiedBy: '08:00 pm by Kevin Doglas', shareStatus: 'Active', shareClass: 'text-bg-theme-1 theme-green', fileSize: '25.5 MB' }
    ], []);

    const innersidebar = () => {
        setMenuClosed(prev => !prev);
    };

    return (
        <>
            {/* page title */}
            <div className="container py-3">
                <div className="row align-items-center page-title">
                    <div className="col col-sm mb-3 mb-sm-0">
                        <h6 className="mb-0">File Explorer</h6>
                        <p className="text-secondary small">Manage Space with Files Management</p>
                    </div>
                    <div className="col-auto ps-0 position-relative mb-3 mb-sm-0">
                        <button className="btn btn-link btn-square" type="button" data-bs-toggle="offcanvas" data-bs-target="#filter" aria-expanded="false">
                            <i className="bi bi-funnel"></i>
                        </button>
                    </div>
                </div>
                <nav aria-label="breadcrumb" className="breadcrumb-theme bg-theme-1-subtle px-2 py-1 mt-0 mt-sm-3 rounded">
                    <ol className="breadcrumb mb-0">
                        <li className="breadcrumb-item bi"><Link to="/app/dashboard"><i className="bi bi-house-door me-2"></i> DevUIUX</Link></li>
                        <li className="breadcrumb-item bi active" aria-current="page">Explorer</li>
                    </ol>
                </nav>
            </div>

            {/* content */}
            <div className="container" id="main-content">
                <div className="row gx-3 gx-lg-4">
                    {/* summary blocks */}
                    <div className="col-6 col-sm-6 col-lg-6 col-xxl-3">
                        <div className="card mb-3 mb-lg-4 mt-4">
                            <div className="card-body">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto text-center">
                                        <div className="mt--50 position-relative">
                                            <div className="avatar avatar-60 card rounded-circle text-center shadow-sm mb-2 position-relative p-1">
                                                <CircleProgress percentage={75} color="#471ca8" size={60} />
                                                <div className="avatar avatar-40 h5 position-absolute start-50 top-50 translate-middle bg-theme-1-subtle text-theme-1 rounded-circle">
                                                    <i className="bi bi-globe"></i>
                                                </div>
                                            </div>
                                            <p className="text-secondary small mb-1">6.5 GB</p>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm order-3 order-md-2">
                                        <p className="text-secondary small mb-1">Webspace</p>
                                        <h5>5.5GB <small>used</small></h5>
                                    </div>
                                    <div className="col-auto order-2 order-md-3 ms-auto">
                                        <div className="dropdown d-inline-block">
                                            <a className="text-secondary no-caret" data-bs-toggle="dropdown" aria-expanded="false" data-bs-display="static" role="button">
                                                <i className="bi bi-three-dots-vertical"></i>
                                            </a>
                                            <ul className="dropdown-menu dropdown-menu-end">
                                                <li><a className="dropdown-item" href="javascript:void(0)">Edit</a></li>
                                                <li><a className="dropdown-item" href="javascript:void(0)">Move</a></li>
                                                <li><a className="dropdown-item text-danger" href="javascript:void(0)">Delete</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-sm-6 col-lg-6 col-xxl-3">
                        <div className="card mb-3 mb-lg-4 mt-4">
                            <div className="card-body">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto text-center">
                                        <div className="mt--50 position-relative">
                                            <div className="avatar avatar-60 card rounded-circle text-center shadow-sm mb-2 position-relative p-1">
                                                <CircleProgress percentage={75} color="#fcab16" size={60} />
                                                <div className="avatar avatar-40 h5 position-absolute start-50 top-50 translate-middle bg-theme-1-subtle text-theme-1 theme-yellow rounded-circle">
                                                    <i className="bi bi-file-earmark-richtext"></i>
                                                </div>
                                            </div>
                                            <p className="text-secondary small mb-1">3500k </p>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm order-3 order-md-2">
                                        <p className="text-secondary small mb-1">Server</p>
                                        <h5>2569k<small>Files</small></h5>
                                    </div>
                                    <div className="col-auto order-2 order-md-3 ms-auto">
                                        <div className="dropdown d-inline-block">
                                            <a className="text-secondary no-caret" data-bs-toggle="dropdown" aria-expanded="false" data-bs-display="static" role="button">
                                                <i className="bi bi-three-dots-vertical"></i>
                                            </a>
                                            <ul className="dropdown-menu dropdown-menu-end">
                                                <li><a className="dropdown-item" href="javascript:void(0)">Edit</a></li>
                                                <li><a className="dropdown-item" href="javascript:void(0)">Move</a></li>
                                                <li><a className="dropdown-item text-danger" href="javascript:void(0)">Delete</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-sm-6 col-lg-6 col-xxl-3">
                        <div className="card mb-3 mb-lg-4 mt-4">
                            <div className="card-body">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto text-center">
                                        <div className="mt--50 position-relative">
                                            <div className="avatar avatar-60 card rounded-circle text-center shadow-sm mb-2 position-relative p-1">
                                                <CircleProgress percentage={75} color="#c80036" size={60} />
                                                <div className="avatar avatar-40 h5 position-absolute start-50 top-50 translate-middle bg-theme-1-subtle text-theme-1 theme-red rounded-circle">
                                                    <i className="bi bi-device-ssd"></i>
                                                </div>
                                            </div>
                                            <p className="text-secondary small mb-1">1.5 TB</p>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm order-3 order-md-2">
                                        <p className="text-secondary small mb-1">SSD used</p>
                                        <h5>1.15<small>TB</small></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-sm-6 col-lg-6 col-xxl-3">
                        <div className="card adminuiux-card bg-theme-1 mb-3 mb-lg-4 mt-4">
                            <div className="card-body bg-none">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto text-center order-1">
                                        <div className="mt--50 position-relative">
                                            <div className="avatar avatar-60 bg-theme-1 rounded-circle text-center shadow mb-2 position-relative p-1">
                                                <CircleProgress percentage={75} color="#ffffff" size={60} />
                                                <div className="avatar avatar-30 position-absolute start-50 top-50 translate-middle bg-white-opacity text-white rounded-circle">
                                                    <i className="bi bi-envelope-check"></i>
                                                </div>
                                            </div>
                                            <p className="text-white opacity-5 small mb-1">$ 1.5k</p>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm order-3 order-md-2">
                                        <p className="opacity-75 small mb-1">Bills</p>
                                        <h5>186 <small>USD</small></h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row gx-3 gx-lg-4">
                    {/* summary*/}
                    <div className="col-6 col-sm-6 col-lg-6 col-xxl-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto order-1">
                                        <div className="avatar avatar-50 rounded bg-theme-1 theme-purple text-white">
                                            <i className="bi bi-file-earmark-text h5 vm"></i>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm order-3 order-sm-2 mt-3 mt-sm-0">
                                        <h6 className="mb-1">Docs</h6>
                                        <p className="text-secondary">1254 files</p>
                                    </div>
                                    <div className="col-auto order-2 order-sm-3 ms-auto">
                                        <div className="avatar avatar-50 mx-auto rounded-circle">
                                            <CircleProgress percentage={75} color="#471ca8" size={50} fillText={true} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-sm-6 col-lg-6 col-xxl-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto order-1">
                                        <div className="avatar avatar-50 rounded bg-theme-1 theme-green text-white">
                                            <i className="bi bi-file-earmark-music h5 vm"></i>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm order-3 order-sm-2 mt-3 mt-sm-0">
                                        <h6 className="mb-1">Musics</h6>
                                        <p className="text-secondary">3200 files</p>
                                    </div>
                                    <div className="col-auto order-2 order-sm-3 ms-auto">
                                        <div className="avatar avatar-50 mx-auto rounded-circle">
                                            <CircleProgress percentage={75} color="#08a046" size={50} fillText={true} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-sm-6 col-lg-6 col-xxl-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto order-1">
                                        <div className="avatar avatar-50 rounded bg-theme-1 theme-yellow text-white">
                                            <i className="bi bi-file-earmark-play h5 vm"></i>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm order-3 order-sm-2 mt-3 mt-sm-0">
                                        <h6 className="mb-1">Videos</h6>
                                        <p className="text-secondary">165 files</p>
                                    </div>
                                    <div className="col-auto order-2 order-sm-3 ms-auto">
                                        <div className="avatar avatar-50 mx-auto rounded-circle">
                                            <CircleProgress percentage={75} color="#fcab16" size={50} fillText={true} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-6 col-sm-6 col-lg-6 col-xxl-3">
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-body">
                                <div className="row gx-3 align-items-center">
                                    <div className="col-auto order-1">
                                        <div className="avatar avatar-50 rounded bg-theme-1 theme-red text-white">
                                            <i className="bi bi-file-earmark-richtext h5 vm"></i>
                                        </div>
                                    </div>
                                    <div className="col-12 col-sm order-3 order-sm-2 mt-3 mt-sm-0">
                                        <h6 className="mb-1">Other</h6>
                                        <p className="text-secondary">2589 files</p>
                                    </div>
                                    <div className="col-auto order-2 order-sm-3 ms-auto">
                                        <div className="avatar avatar-50 mx-auto rounded-circle">
                                            <CircleProgress percentage={75} color="#c80036" size={50} fillText={true} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="container-fluid">
                <div className="row gx-3 gx-lg-4">
                    <div className="col-12 px-0">
                        <div className="height-150">
                            <AreaChart labels={['1', '2', '3', '4', '5', '7', '8', '9', '10']}
                                datasets={[
                                    {
                                        data: [15, 10, 30, 15, 12, 10, 20, 15, 25, 20,],
                                        label: 'New Users',
                                        color: '#e57463',
                                        fillColor: 'rgba(229, 116, 99, 0.5)',
                                        borderWidth: 1,
                                        pointBackgroundColor: '#e57463',
                                        pointBorderColor: '#ffffff',
                                        pointRadius: 2,
                                        tension: 0.4,
                                        borderColor: '#e57463',
                                    },
                                    {
                                        data: [20, 15, 15, 10, 20, 15, 25, 20, 10, 30],
                                        label: 'Clients',
                                        color: '#fcab16',
                                        fillColor: 'rgba(252, 171, 22, 0.5)',
                                        borderWidth: 1,
                                        pointBackgroundColor: '#fcab16',
                                        pointBorderColor: '#ffffff',
                                        pointRadius: 2,
                                        tension: 0.4,
                                        borderColor: '#fcab16',
                                    },
                                    {
                                        data: [15, 10, 20, 15, 25, 20, 15, 10, 30, 15],
                                        label: 'Jobs',
                                        color: '#4d10f2',
                                        fillColor: 'rgba(77, 16, 242, 0.5)',
                                        borderWidth: 1,
                                        pointBackgroundColor: '#4d10f2',
                                        pointBorderColor: '#ffffff',
                                        pointRadius: 2,
                                        tension: 0.4,
                                        borderColor: '#4d10f2',
                                    },
                                ]}
                                scalesx={false}
                                scalesy={false}
                                height={150} />
                        </div>
                    </div>
                </div>
                <div className="row gx-3 gx-lg-4 mb-3">
                    <div className="col text-center py-3">
                        <h4>Better you manage space, <span className="text-gradient">Awesome things</span> you will get soon</h4>
                        <p className="text-secondary">Files Management and all possible are on demand in digital age transformation.</p>
                    </div>
                </div>
            </div>
            <div className="container">

                <ul className="nav rounded p-1 mb-3">
                    <li className="nav-item">
                        <button className="btn btn-square btn-link" onClick={innersidebar}><i className="bi bi-layout-sidebar h5 vm"></i></button>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" ><i className="bi bi-folder-plus h6 vm"></i></a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" ><i className="bi bi-trash vm"></i></a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link" ><i className="bi bi-exclamation-circle vm"></i></a>
                    </li>
                    <li className="nav-item d-none d-md-block">
                        <div className="input-group input-group-sm my-1 w-100 mx-1">
                            <input type="text" className="form-control bg-transparent" placeholder="Search mail... " defaultValue={""} />
                            <button className="btn btn-link border" type="button">
                                <i className="bi bi-search"></i>
                            </button>
                        </div>
                    </li>
                    <li className="nav-item  ms-auto">
                        <a className="nav-link" ><i className="bi bi-question-circle"></i></a>
                    </li>
                    <li className="nav-item">
                        <a className="nav-link d-inline-block" ><i className="bi bi-chevron-left"></i></a>
                        <span className="d-none d-xl-inline-block vm">15 out of 12548</span>
                        <a className="nav-link d-inline-block" ><i className="bi bi-chevron-right"></i></a>
                    </li>
                </ul>
                <div className="inner-sidebar-wrap">
                    <div className="inner-sidebar height-dynamic px-3" style={{ "--h-dynamic": "auto" } as React.CSSProperties}>
                        <button className="btn btn-light py-3 mb-3 mb-lg-4 w-100 shadow-sm" type="button" data-bs-toggle="modal" data-bs-target="#addfile"><i className="bi bi-plus me-2 vm"></i> Upload File</button>

                        <ul className="nav nav-pills flex-column mb-3 mb-lg-4">
                            <li className="nav-item">
                                <a className="nav-link active" aria-current="page" >
                                    <div className="avatar avatar-30 icon rounded-circle"><i className="bi bi-clock-history"></i></div>
                                    <div className="col">Recently Uploaded</div>
                                </a>
                            </li>
                            <li className="nav-item dropdown">
                                <a className="nav-link dropdown-toggle" data-bs-toggle="dropdown" data-bs-auto-close="false" data-bs-display="static" role="button" aria-expanded="false">
                                    <div className="avatar avatar-30 icon rounded-circle"><i className="bi bi-folder"></i></div>
                                    <div className="col">My Files</div>
                                </a>
                                <ul className="dropdown-menu">
                                    <li>
                                        <a className="dropdown-item nav-link" >
                                            <div className="avatar avatar-30 icon rounded-circle"><i className="bi bi-folder"></i>
                                            </div>
                                            <div className="col align-self-center">Webspace</div>
                                            <div className="col-auto align-items-center">
                                                <figure className="avatar avatar-20 bg-theme-1-subtle text-theme-1 rounded-circle">
                                                    <small className="fs-10 vm">+5</small>
                                                </figure>
                                            </div>
                                            <div className="arrow"><i className="bi bi-chevron-right"></i></div>
                                        </a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item nav-link" >
                                            <div className="avatar avatar-30 icon rounded-circle"><i className="bi bi-folder"></i>
                                            </div>
                                            <div className="col align-self-center">Server</div>
                                            <div className="arrow"><i className="bi bi-chevron-right"></i></div>
                                        </a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item nav-link" >
                                            <div className="avatar avatar-30 icon rounded-circle"><i className="bi bi-folder"></i>
                                            </div>
                                            <div className="col align-self-center">SSD</div>
                                            <div className="arrow"><i className="bi bi-chevron-right"></i></div>
                                        </a>
                                    </li>
                                    <li>
                                        <a className="dropdown-item nav-link" >
                                            <div className="avatar avatar-30 icon rounded-circle"><i className="bi bi-folder"></i>
                                            </div>
                                            <div className="col align-self-center">Pen Drive</div>
                                            <div className="arrow"><i className="bi bi-chevron-right"></i></div>
                                        </a>
                                    </li>
                                </ul>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" aria-current="page" >
                                    <div className="avatar avatar-30 icon rounded-circle"><i className="bi bi-people"></i></div>
                                    <div className="col">Shared with me</div>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" aria-current="page" >
                                    <div className="avatar avatar-30 icon rounded-circle"><i className="bi bi-heart"></i></div>
                                    <div className="col">Favorite</div>
                                </a>
                            </li>
                            <li className="nav-item">
                                <a className="nav-link" aria-current="page" >
                                    <div className="avatar avatar-30 icon rounded-circle"><i className="bi bi-trash"></i></div>
                                    <div className="col">Trashed</div>
                                </a>
                            </li>
                        </ul>

                        <div className="row gx-3">
                            <div className="col-auto mb-3 mb-lg-4">
                                <div className="rounded bg-theme-1 p-2 text-center">
                                    <i className="bi bi-cloud h4"></i>
                                    <p className="small">Cloud</p>
                                </div>
                            </div>
                            <div className="col align-self-center mb-3 mb-lg-4">
                                <h6>Storage</h6>
                                <div>
                                    <div className="progress height-dynamic mb-1 bg-theme-1-subtle" style={{ "--h-dynamic": "5px" } as React.CSSProperties}>
                                        <div className="progress-bar bg-theme-1 w-50" role="progressbar"></div>
                                    </div>
                                </div>
                                <p className="small text-secondary">5.4GB of 6GB used</p>
                            </div>
                        </div>
                        <div className="card adminuiux-card bg-theme-l-gradient theme-yellow mb-3">
                            <div className="card-body">
                                <div className="row gx-3 mb-2">
                                    <div className="col">
                                        <p className="mb-0"><i className="bi bi-basket me-1 "></i> Free Plan</p>
                                    </div>
                                    <div className="col-auto">
                                        <p className="small opacity-75">4 days left</p>
                                    </div>
                                </div>
                                <div className="progress height-dynamic bg-theme-1-subtle theme-red mb-2" role="progressbar" aria-label="Basic example" aria-valuenow={0} aria-valuemin={0} aria-valuemax={100} style={{ "--h-dynamic": "5px" } as React.CSSProperties}>
                                    <div className="progress-bar progress-bar-striped progress-bar-animated bg-theme-1" style={{ width: "45%" }}></div>
                                </div>
                                <a href="subscription-upgrade.html" className="btn btn-sm btn-accent">Upgrade <i className="bi bi-arrow-right"></i></a>
                            </div>
                        </div>

                    </div>
                    <div className="inner-sidebar-content px-2 px-lg-3">
                        <div className="row gx-3 gx-lg-4">
                            <div className="col-12 col-md-4 col-lg-6 col-xl-3">
                                <div className="card  adminuiux-card shadow-sm overflow-hidden mb-3 mb-lg-4">
                                    <div className="height-150 w-100 coverimg">
                                        <img src={asset('assets/img/adminuiux/image-3.jpg')} className="mw-100" alt="" />
                                    </div>
                                    <div className="card-footer bg-none">
                                        <div className="row gx-3 align-items-center">
                                            <div className="col-auto">
                                                <a href="javascript:void(0)" className="avatar avatar-30 rounded text-red mr-3">
                                                    <i className="bi bi-file-earmark-pdf h5 vm"></i>
                                                </a>
                                            </div>
                                            <div className="col maxwidth-dynamic" style={{ "--mw-dynamic": "calc(100% - 55px)" } as React.CSSProperties}>
                                                <p className="mb-0 text-truncated">Construction-portal.pdf</p>
                                                <p className="small text-secondary">28/02/2022</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-4 col-lg-6 col-xl-3">
                                <div className="card  adminuiux-card shadow-sm overflow-hidden mb-3 mb-lg-4">
                                    <div className="height-150 w-100 coverimg">
                                        <img src={asset('assets/img/adminuiux/image-4.jpg')} className="mw-100" alt="" />
                                    </div>
                                    <div className="card-footer bg-none">
                                        <div className="row gx-3 align-items-center">
                                            <div className="col-auto">
                                                <a href="javascript:void(0)" className="avatar avatar-30 rounded text-red mr-3">
                                                    <i className="bi bi-file-earmark-pdf h5 vm"></i>
                                                </a>
                                            </div>
                                            <div className="col maxwidth-dynamic" style={{ "--mw-dynamic": "calc(100% - 55px)" } as React.CSSProperties}>
                                                <p className="mb-0 text-truncated">networking.pdf</p>
                                                <p className="small text-secondary">28/02/2022</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-4 col-lg-6 col-xl-3">
                                <div className="card  adminuiux-card shadow-sm overflow-hidden mb-3 mb-lg-4">
                                    <div className="height-150 w-100 coverimg">
                                        <img src={asset('assets/img/adminuiux/image-1.jpg')} className="mw-100" alt="" />
                                    </div>
                                    <div className="card-footer bg-none">
                                        <div className="row gx-3 align-items-center">
                                            <div className="col-auto">
                                                <a href="javascript:void(0)" className="avatar avatar-30 rounded text-red mr-3">
                                                    <i className="bi bi-file-earmark-pdf h5 vm"></i>
                                                </a>
                                            </div>
                                            <div className="col maxwidth-dynamic" style={{ "--mw-dynamic": "calc(100% - 55px)" } as React.CSSProperties}>
                                                <p className="mb-0 text-truncated">savemoremoney.pdf</p>
                                                <p className="small text-secondary">28/02/2022</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-4 col-lg-6 col-xl-3">
                                <div className="card  adminuiux-card shadow-sm overflow-hidden mb-3 mb-lg-4">
                                    <div className="height-150 w-100 coverimg">
                                        <img src={asset('assets/img/adminuiux/image-2.jpg')} className="mw-100" alt="" />
                                    </div>
                                    <div className="card-footer bg-none">
                                        <div className="row gx-3 align-items-center">
                                            <div className="col-auto">
                                                <a href="javascript:void(0)" className="avatar avatar-30 rounded text-red mr-3">
                                                    <i className="bi bi-file-earmark-pdf h5 vm"></i>
                                                </a>
                                            </div>
                                            <div className="col maxwidth-dynamic" style={{ "--mw-dynamic": "calc(100% - 55px)" } as React.CSSProperties}>
                                                <p className="mb-0 text-truncated">Kitchen_colors_defination.jpg</p>
                                                <p className="small text-secondary">28/02/2022</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="row gx-3 align-items-center mb-3 mb-lg-4">
                            <div className="col-auto">
                                <i className="bi bi-folder h5 avatar avatar-40 bg-theme-1-subtle text-theme-1 rounded"></i>
                            </div>
                            <div className="col">
                                <h6 className="mb-0">Folders</h6>
                                <p className="small text-secondary">Recently viewed by <a>Alliana Smith</a></p>
                            </div>
                            <div className="col-auto">
                                <button className="btn btn-sm btn-link"><i className="bi bi-arrow-down"></i></button>
                            </div>
                        </div>
                        <div className="row gx-3 gx-lg-4">
                            <div className="col-12 col-md-4 col-lg-6 col-xl-3">
                                <a className="card adminuiux-card shadow-sm mb-3 mb-lg-4">
                                    <div className="card-body">
                                        <div className="row gx-3 align-items-center">
                                            <div className="col-auto">
                                                <div className="avatar avatar-30 rounded text-theme-1">
                                                    <i className="bi bi-folder-fill h5 vm"></i>
                                                </div>
                                            </div>
                                            <div className="col maxwidth-dynamic" style={{ "--mw-dynamic": "calc(100% - 55px)" } as React.CSSProperties}>
                                                <p className="mb-0 text-truncated">William's School</p>
                                                <p className="small text-secondary">18 Files</p>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="col-12 col-md-4 col-lg-6 col-xl-3">
                                <a className="card adminuiux-card shadow-sm mb-3 mb-lg-4">
                                    <div className="card-body">
                                        <div className="row gx-3 align-items-center">
                                            <div className="col-auto">
                                                <div className="avatar avatar-30 rounded text-theme-1">
                                                    <i className="bi bi-folder-fill h5 vm"></i>
                                                </div>
                                            </div>
                                            <div className="col maxwidth-dynamic" style={{ "--mw-dynamic": "calc(100% - 55px)" } as React.CSSProperties}>
                                                <p className="mb-0 text-truncated">Music Audition</p>
                                                <p className="small text-secondary">3 Files</p>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="col-12 col-md-4 col-lg-6 col-xl-3">
                                <a className="card adminuiux-card shadow-sm mb-3 mb-lg-4">
                                    <div className="card-body">
                                        <div className="row gx-3 align-items-center">
                                            <div className="col-auto">
                                                <div className="avatar avatar-30 rounded text-theme-1">
                                                    <i className="bi bi-folder-fill h5 vm"></i>
                                                </div>
                                            </div>
                                            <div className="col maxwidth-dynamic" style={{ "--mw-dynamic": "calc(100% - 55px)" } as React.CSSProperties}>
                                                <p className="mb-0 text-truncated">Housing Papers</p>
                                                <p className="small text-secondary">6 Files</p>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="col-12 col-md-4 col-lg-6 col-xl-3">
                                <a className="card adminuiux-card shadow-sm mb-3 mb-lg-4">
                                    <div className="card-body">
                                        <div className="row gx-3 align-items-center">
                                            <div className="col-auto">
                                                <div className="avatar avatar-30 rounded text-theme-1">
                                                    <i className="bi bi-folder-fill h5 vm"></i>
                                                </div>
                                            </div>
                                            <div className="col maxwidth-dynamic" style={{ "--mw-dynamic": "calc(100% - 55px)" } as React.CSSProperties}>
                                                <p className="mb-0 text-truncated">Lisa's Tuition</p>
                                                <p className="small text-secondary">4 Files</p>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="col-12 col-md-4 col-lg-6 col-xl-3">
                                <a className="card adminuiux-card shadow-sm mb-3 mb-lg-4">
                                    <div className="card-body">
                                        <div className="row gx-3 align-items-center">
                                            <div className="col-auto">
                                                <div className="avatar avatar-30 rounded text-theme-1">
                                                    <i className="bi bi-folder-fill h5 vm"></i>
                                                </div>
                                            </div>
                                            <div className="col maxwidth-dynamic" style={{ "--mw-dynamic": "calc(100% - 55px)" } as React.CSSProperties}>
                                                <p className="mb-0 text-truncated">Bills Housing</p>
                                                <p className="small text-secondary">8 Files</p>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="col-12 col-md-4 col-lg-6 col-xl-3">
                                <a className="card adminuiux-card shadow-sm mb-3 mb-lg-4">
                                    <div className="card-body">
                                        <div className="row gx-3 align-items-center">
                                            <div className="col-auto">
                                                <div className="avatar avatar-30 rounded text-theme-1">
                                                    <i className="bi bi-folder-fill h5 vm"></i>
                                                </div>
                                            </div>
                                            <div className="col maxwidth-dynamic" style={{ "--mw-dynamic": "calc(100% - 55px)" } as React.CSSProperties}>
                                                <p className="mb-0 text-truncated">Trip Photos</p>
                                                <div className="row gx-3">
                                                    <div className="col">
                                                        <p className="small text-secondary">16 Files</p>
                                                    </div>
                                                    <div className="col-auto small"><i className="bi bi-share me-1 fs-12"></i> Shared</div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                            <div className="col-12 col-md-4 col-lg-6 col-xl-3">
                                <a className="card adminuiux-card shadow-sm mb-3 mb-lg-4">
                                    <div className="card-body">
                                        <div className="row gx-3 align-items-center">
                                            <div className="col-auto">
                                                <div className="avatar avatar-30 rounded text-theme-1">
                                                    <i className="bi bi-folder-fill h5 vm"></i>
                                                </div>
                                            </div>
                                            <div className="col maxwidth-dynamic" style={{ "--mw-dynamic": "calc(100% - 55px)" } as React.CSSProperties}>
                                                <p className="mb-0 text-truncated">Money Presentation</p>
                                                <p className="small text-secondary">10 Files</p>
                                            </div>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div className="row gx-3 align-items-center mb-3 mb-lg-4">
                            <div className="col-auto">
                                <i className="bi bi-file-earmark-richtext h5 avatar avatar-40 bg-theme-1-subtle text-theme-1 theme-green rounded"></i>
                            </div>
                            <div className="col">
                                <h6 className="mb-0">Files</h6>
                                <p className="small text-secondary">Recently added by <a>Yaan Lee</a></p>
                            </div>
                            <div className="col-auto">
                                <button className="btn btn-sm btn-link"><i className="bi bi-arrow-down"></i></button>
                            </div>
                        </div>
                        <div className="row gx-3 gx-lg-4">
                            <div className="col-12 col-md-4 col-lg-6 col-xl-3">
                                <div className="card  adminuiux-card shadow-sm overflow-hidden mb-3 mb-lg-4">
                                    <div className="height-150 w-100 coverimg">
                                        <img src={asset('assets/img/adminuiux/image-3.jpg')} className="mw-100" alt="" />
                                    </div>
                                    <div className="card-footer bg-none">
                                        <div className="row gx-3 align-items-center">
                                            <div className="col-auto">
                                                <a href="javascript:void(0)" className="avatar avatar-30 rounded text-red mr-3">
                                                    <i className="bi bi-file-earmark-pdf h5 vm"></i>
                                                </a>
                                            </div>
                                            <div className="col maxwidth-dynamic" style={{ "--mw-dynamic": "calc(100% - 55px)" } as React.CSSProperties}>
                                                <p className="mb-0 text-truncated">Construction-portal.pdf</p>
                                                <p className="small text-secondary">28/02/2022</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-4 col-lg-6 col-xl-3">
                                <div className="card  adminuiux-card shadow-sm overflow-hidden mb-3 mb-lg-4">
                                    <div className="height-150 w-100 coverimg">
                                        <img src={asset('assets/img/adminuiux/image-2.jpg')} className="mw-100" alt="" />
                                    </div>
                                    <div className="card-footer bg-none">
                                        <div className="row gx-3 align-items-center">
                                            <div className="col-auto">
                                                <a href="javascript:void(0)" className="avatar avatar-30 rounded text-red mr-3">
                                                    <i className="bi bi-file-earmark-pdf h5 vm"></i>
                                                </a>
                                            </div>
                                            <div className="col maxwidth-dynamic" style={{ "--mw-dynamic": "calc(100% - 55px)" } as React.CSSProperties}>
                                                <p className="mb-0 text-truncated">networking.pdf</p>
                                                <p className="small text-secondary">28/02/2022</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-4 col-lg-6 col-xl-3">
                                <div className="card  adminuiux-card shadow-sm overflow-hidden mb-3 mb-lg-4">
                                    <div className="height-150 w-100 coverimg">
                                        <img src={asset('assets/img/adminuiux/image-4.jpg')} className="mw-100" alt="" />
                                    </div>
                                    <div className="card-footer bg-none">
                                        <div className="row gx-3 align-items-center">
                                            <div className="col-auto">
                                                <a href="javascript:void(0)" className="avatar avatar-30 rounded text-red mr-3">
                                                    <i className="bi bi-file-earmark-pdf h5 vm"></i>
                                                </a>
                                            </div>
                                            <div className="col maxwidth-dynamic" style={{ "--mw-dynamic": "calc(100% - 55px)" } as React.CSSProperties}>
                                                <p className="mb-0 text-truncated">savemoremoney.pdf</p>
                                                <p className="small text-secondary">28/02/2022</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-md-4 col-lg-6 col-xl-3">
                                <div className="card  adminuiux-card shadow-sm overflow-hidden mb-3 mb-lg-4">
                                    <div className="height-150 w-100 coverimg">
                                        <img src={asset('assets/img/adminuiux/image-1.jpg')} className="mw-100" alt="" />
                                    </div>
                                    <div className="card-footer bg-none">
                                        <div className="row gx-3 align-items-center">
                                            <div className="col-auto">
                                                <a href="javascript:void(0)" className="avatar avatar-30 rounded text-red mr-3">
                                                    <i className="bi bi-file-earmark-pdf h5 vm"></i>
                                                </a>
                                            </div>
                                            <div className="col maxwidth-dynamic" style={{ "--mw-dynamic": "calc(100% - 55px)" } as React.CSSProperties}>
                                                <p className="mb-0 text-truncated">Kitchen_colors_defination.jpg</p>
                                                <p className="small text-secondary">28/02/2022</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Grid table*/}
                        <div className="card mb-3 mb-lg-4">
                            <div className="card-header">
                                <div className="row gx-3">
                                    <div className="col-auto mb-3 mb-xl-0">
                                        <i className="bi bi-people h5 avatar avatar-40 bg-theme-1-subtle text-theme-1 theme-yellow rounded"></i>
                                    </div>
                                    <div className="col-9 col-xl mb-3 mb-xl-0">
                                        <h6 className="mb-0">Shared with me</h6>
                                        <p className="small text-secondary">Sharpen trending products</p>
                                    </div>
                                    <div className="col-6 col-xl-auto">
                                        <select className="form-select">
                                            <option>All Categories</option>
                                            <option>Shared</option>
                                            <option>Uploaded by me</option>
                                            <option>Favorite</option>
                                        </select>
                                    </div>
                                    <div className="col-6 col-xl-auto">
                                        <div className="input-group ">
                                            <span className="input-group-text text-theme-1"><i className="bi bi-search"></i></span>
                                            <input type="text" className="form-control" placeholder="Search..." onChange={(e) => dtApi?.search(e.target.value).draw()} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card-body pt-0">
                                <DataTable className="table mb-3" options={options}>
                                    <thead>
                                        <tr className="text-muted">
                                            <th className="all">File Name</th>
                                            <th className="none">Date Created</th>
                                            <th className="none">Date Modified</th>
                                            <th className="desktop">Share Status</th>
                                            <th className="desktop">File size</th>
                                            <th className="all"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {filesData.map((file, index) => (
                                            <tr key={index}>
                                                <td>
                                                    <div className="row gx-3 align-items-center flex-nowrap">
                                                        <div className="col-auto">
                                                            <figure className="avatar avatar-40 mb-0 coverimg rounded">
                                                                <img src={window.asset ? window.asset(file.image) : file.image} alt="" />
                                                            </figure>
                                                        </div>
                                                        <div className="col maxwidth-dynamic" style={{ "--mw-dynamic": "180px" } as React.CSSProperties}>
                                                            <p className="mb-0 text-truncated">{file.name}</p>
                                                            <p className="text-secondary small text-truncated">
                                                                <i className={`bi ${file.favorite ? 'bi-heart-fill' : 'bi-heart'} text-red small vm`}></i> {file.uploadedBy}
                                                            </p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <p className="mb-0">{file.dateCreated}</p>
                                                    <p className="text-secondary small">{file.timeCreated}</p>
                                                </td>
                                                <td>
                                                    <p className="mb-0">{file.dateModified}</p>
                                                    <p className="text-secondary small">{file.modifiedBy}</p>
                                                </td>
                                                <td>
                                                    <span className={`badge badge-light ${file.shareClass}`}>{file.shareStatus}</span>
                                                </td>
                                                <td>
                                                    {file.fileSize}
                                                </td>
                                                <td>
                                                    <div className="dropdown d-inline-block">
                                                        <a className="text-secondary no-caret" data-bs-toggle="dropdown" aria-expanded="false" role="button">
                                                            <i className="bi bi-three-dots"></i>
                                                        </a>
                                                        <ul className="dropdown-menu dropdown-menu-end">
                                                            <li><a className="dropdown-item" href="javascript:void(0)">Edit</a></li>
                                                            <li><a className="dropdown-item" href="javascript:void(0)">Move</a></li>
                                                            <li><a className="dropdown-item text-danger" href="javascript:void(0)">Delete</a></li>
                                                        </ul>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </DataTable>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            {/* modal compose email */}
            <div className="modal fade adminuiux-modal" id="addfile" aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered ">
                    <div className="modal-content">
                        <div className="modal-header">
                            <p className="h6">Create New Email</p>
                        </div>
                        <div className="modal-body d-block">

                            {/* dropzone */}
                            <form action="/target" className="dropzone mb-3" id="myDropzone2">
                                <div className="dz-default dz-message my-2">
                                    <i className="h1 bi bi-cloud-upload"></i><br />
                                    <button className="dz-button" type="button">Drag and Drop or Click here to upload</button>
                                </div>
                            </form>

                            {/* Title */}
                            <div className="form-floating mb-2">
                                <input type="text" className="form-control" id="filename" placeholder="File Name" />
                                <label htmlFor="filename">File Name</label>
                            </div>

                            <p className="text-secondary small">Upload only .jpeg, .png, .mp4, .mpeg4 file format max. file
                                size 6MB</p>

                            {/* Title */}
                            <div className="form-floating mb-3">
                                <input type="text" className="form-control" id="sendto" placeholder="Select Send to" defaultValue="cotact@testmail.com" />
                                <label htmlFor="sendto">Share with</label>
                            </div>

                            <div className="row gx-3">
                                <div className="col">
                                    <button className="btn btn-link theme-red" type="button" data-bs-dismiss="modal"><i className="bi bi-trash h4 me-2"></i> Discard</button>
                                </div>
                                <div className="col-auto">
                                    <button className="btn btn-theme" type="button"><i className="bi bi-send me-2"></i> Send</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Explorer;
